import script from "./AdminDaytourTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDaytourTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminDaytourTable.vue?vue&type=style&index=0&id=3a7b7635&lang=css"

const __exports__ = script;

export default __exports__